import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import React from 'react';

import AccountSettings from '@/src/profile/accountSettings/containers/AccountSettings';

const MyProfileAccountSettingsPage = () => {
  return <AccountSettings />;
};

export default MyProfileAccountSettingsPage;

export const getStaticProps = async ({locale}) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});
